import { createApi } from '@reduxjs/toolkit/query/react';
import { z } from 'zod';
import { baseQuery } from './baseQuery';
import { validateResponse } from './validateResponse';

export const ExhibitsDisplaysV3StubSchema = z.object({ message: z.string() });
export type ExhibitsDisplaysV3Stub = z.infer<typeof ExhibitsDisplaysV3StubSchema>;

export const exhibitsDisplaysV3Api = createApi({
    reducerPath: 'exhibitsDisplaysV3Api',
    baseQuery,
    endpoints: (builder) => ({
        getExhibitsDisplaysV3: builder.query<ExhibitsDisplaysV3Stub, void>({
            query: () => 'api/v3/exhibitsdisplays',
            transformResponse: validateResponse(ExhibitsDisplaysV3StubSchema),
        }),
    }),
});

export const { useGetExhibitsDisplaysV3Query } = exhibitsDisplaysV3Api;
